import React, { useEffect, useState } from "react";
import UITransition from "../../ui/Transition";
import { CustomStyleProvider } from "../../utils/CustomStyleProvider";
import { Col, Row } from "antd";
import { UITitle } from "../../ui/Title";
import { BaseColor } from "../../../theme/maps/Colors";
import { TUser } from "../../../redux-modules/declarations/maps/auth";
import apiClient from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../constants/api";
import { ShiftGrid } from "./shift_grid";

export const ViewGridDailyShift = (): JSX.Element => {

    const [userList, setUserList] = useState<TUser[]>([]);

    useEffect(() => {
        apiClient.get(API_ENDPOINTS.USERS_LIST + "?all=true").then(res => {
            setUserList(res.data.data);
        });
    }, []);

    return (
        <>
            <UITransition>
                <CustomStyleProvider section="Shifts">
                    <Row justify="space-between" align="middle" gutter={[16, 16]}>
                        <Col style={{ display: "inline-flex", alignItems: "baseline" }}>
                            <UITitle level={2} color={BaseColor}>
                                Turni
                            </UITitle>
                        </Col>
                    </Row>

                    {userList.length > 0 && (
                        <ShiftGrid userList={userList} />
                    )}
                    
                </CustomStyleProvider>
            </UITransition>
        </>
    );
}